import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../authentication/auth.service';
import {KitModel, Kit, Device, MagmaResponse, AlertLimit, GraphEntity} from '../models';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  deviceName = new BehaviorSubject('');
  deviceNameObserv = this.deviceName.asObservable();
  public isNoData = false;

  constructor(private http: HttpClient) {
  }


  forgotPassword(entity: any) {
    return this.http.post<any>(
      environment.host + '/request-reset-password', entity,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json'
          }),
      }
    );
  }


  changePassword(value: any): Observable<any> {
    return this.http.post<any>(
      environment.host + '/change-password',
      value,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  createDevice(device: any): Observable<any> {
    return this.http.post<any>(
      environment.host + '/core/device',
      device,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  getBatches():Observable<any>{
    return this.http.get<any>(
      environment.host + '/core/deviceTest/batchNumbers',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    )
  }

  updateDevice(deviceId, device: any): Observable<any> {
    return this.http.put<any>(
      environment.host + '/core/device/' + deviceId,
      device,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  updateLabels(labeledPoints: { "id": string; "label": string; }[]): Observable<object> {
    return this.http.put(
      environment.host +'/core/device/'+labeledPoints[0].id+'/sensor/changeLabels',
      labeledPoints,
      // {
      //   headers: new HttpHeaders(
      //     {
      //       'Content-Type': 'application/json',
      //       Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      //     }),
      // }
    )
  }

  getDevice(id): Observable<any> {
    return this.http.get<MagmaResponse<Device>>(
      environment.host + '/core/device/' + id,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  deleteDevice(id): Observable<any> {
    return this.http.delete<MagmaResponse<any>>(
      environment.host + '/core/device/' + id,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getDevices(): Observable<any> {
    return this.http.get<MagmaResponse<Device[]>>(
      environment.host + '/core/device',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getOneDevice(coperateId,filter,favourite): Observable<any> {
    const userId = localStorage.getItem('USER_ID')
    if(coperateId===undefined && filter===undefined && favourite===undefined){
      return this.getDevices()
    }
    if(filter==="SensorFailure&sensor" || filter==="ActiveSensors&sensor" || filter==="WrongValued&sensor"){
      return this.http.get<MagmaResponse<Device[]>>(
        environment.host +"/user/"+userId+"/corporate/"+coperateId+"/corporateDevices?dataFilter="+filter+"="+favourite,
        {
          headers: new HttpHeaders(
            {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + AuthService.getAccessToken()
            })
        }
      );
    }
    else{
      return this.http.get<MagmaResponse<Device[]>>(
        environment.host +"/user/"+userId+"/corporate/"+coperateId+"/corporateDevices?dataFilter="+filter+"&favouriteFilter="+favourite,
        {
          headers: new HttpHeaders(
            {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + AuthService.getAccessToken()
            })
        }
      );
    }
  }

  createKit(kit: any): Observable<any> {
    return this.http.post<any>(
      environment.host + '/core/kit-model/' + kit.kitModel + '/kit',
      kit,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  updateKit(kitId, kit: any): Observable<any> {
    return this.http.put<any>(
      environment.host + '/core/kit/' + kitId,
      kit,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  getKits(): Observable<any> {
    return this.http.get<MagmaResponse<Kit[]>>(
      environment.host + '/core/kit',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getKit(id): Observable<any> {
    return this.http.get<MagmaResponse<Kit>>(
      environment.host + '/core/kit/' + id,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  deleteKit(id): Observable<any> {
    return this.http.delete<MagmaResponse<any>>(
      environment.host + '/core/kit/' + id,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  createKitModel(kitModel: any): Observable<any> {

    if (kitModel.properties.includes('B')) {


    }
    return this.http.post<any>(
      environment.host + '/core/kit-model',
      kitModel,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  updateKitModel(kitModelId, kitModel: any): Observable<any> {
    return this.http.put<any>(
      environment.host + '/core/kit-model/' + kitModelId,
      kitModel,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  getKitModel(id): Observable<any> {
    return this.http.get<MagmaResponse<KitModel>>(
      environment.host + '/core/kit-model/' + id,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  deleteKitModel(id): Observable<any> {
    return this.http.delete<MagmaResponse<any>>(
      environment.host + '/core/kit-model/' + id,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getKitModels(): Observable<any> {
    return this.http.get<MagmaResponse<KitModel[]>>(
      environment.host + '/core/kit-model',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  createAlertLimitsForKit(kitId, alertLimit: any): Observable<any> {
    return this.http.post<any>(
      environment.host + '/core/kit/' + kitId + '/property/1/alert-limit',
      alertLimit,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  getOfflineAlertsOfKit(kitId, from, to): Observable<any> {
    return this.http.get<MagmaResponse<any>>(
      environment.host + '/core/kit/' + kitId + '/offline-alerts' + '?from=' + from + '&to=' + to,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  updatePersistence(kitId, value: any): Observable<any> {
    return this.http.put<any>(
      environment.host + '/core/kit/' + kitId + '/persistence',
      value,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  updateMaintenance(kitId, value: any): Observable<any> {
    return this.http.put<any>(
      environment.host + '/core/kit/' + kitId + '/maintain',
      value,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getMetaData(): Observable<any> {
    // return [];
    return this.http.get<MagmaResponse<any>>(
      environment.host + '/core/meta-data',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  // from polar project service

  getProject(projectId): Observable<any> {
    return this.http.get<any>(
      environment.host + '/user/' + AuthService.getUserId() + '/project/' + projectId,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getAlertLimitForProperty(deviceId, propertyId): Observable<MagmaResponse<AlertLimit[]>> {
    return this.http.get<MagmaResponse<AlertLimit[]>>(
      environment.host + '/user/' + AuthService.getUserId() + '/kit/' + deviceId + '/property/' + propertyId + '/alert-limit',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getDeviceHistory(deviceId, from, to, factor): Observable<MagmaResponse<GraphEntity[]>> {
    return this.http.get<MagmaResponse<GraphEntity[]>>(
      environment.host + '/user/' + AuthService.getUserId() + '/kit/' + deviceId + '/property/' + factor + '?from=' + from + '&to=' + to,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getDeviceHistoryAll(deviceId, from, to): Observable<MagmaResponse<GraphEntity[]>> {
    return this.http.get<MagmaResponse<any>>(
      // tslint:disable-next-line:max-line-length
      environment.host + '/core/kit/' + deviceId + '/graph-kit-history/' + '?from=' + from + '&to=' + to,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  getSensorData(deviceId, sensorNumber, from, to) {
    return this.http.get<MagmaResponse<any>>(
      environment.host + '/core/device/' + deviceId + '/sensor/' + sensorNumber + '?from=' + from + '&to=' + to + '&order=' + 'DESC',
      // {
      //   headers: new HttpHeaders(
      //     {
      //       'Content-Type': 'application/json',
      //       Authorization: 'Bearer ' + AuthService.getAccessToken()
      //     })
      // }
    );
  }

  getDevicesSummary() {
    return this.http.get<MagmaResponse<any>>(
      environment.host + '/core/devices-summary',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }

  updateConnectivity(deviceId, body: any): Observable<any> {
    return this.http.post<any>(
      environment.host + '/core/device/' + deviceId + '/connectivity',
      body,
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
          }),
      }
    );
  }

  getConnectivity(deviceId): Observable<any> {
    return this.http.get<MagmaResponse<any>>(
      environment.host + '/core/device/' + deviceId + '/connectivity',
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + AuthService.getAccessToken()
          })
      }
    );
  }
}
